import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementHeaderComponent } from './management-header/management-header.component';
import { ManagementSubHeaderComponent } from './management-sub-header/management-sub-header.component';
import { ManagementOrganizationHeaderComponent } from './management-organization-header/management-organization-header.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [ManagementHeaderComponent, ManagementSubHeaderComponent, ManagementOrganizationHeaderComponent],
    imports: [CommonModule, RouterModule],
    exports: [ManagementHeaderComponent, ManagementSubHeaderComponent, ManagementOrganizationHeaderComponent],
})
export class InsOrgHeadersModule {}
